import { useState, useEffect } from "react";
import moment from "moment";
import axios from "axios";

const underAnalysisStatuses = ["pending", "in_manual_analysis"]
const expiredRefreshAttempts = 6
const expiredRefreshDelay = 3000

export const isUnderAnalysis = (fraud_status) => underAnalysisStatuses.includes(fraud_status)

const computeRemainingSeconds = (limitDate) => (
    limitDate ? Math.max(0, Math.ceil(moment(limitDate).diff(moment()) / 1000)) : null
)

export const useRemainingSeconds = (limitDate) => {
    const [remainingSeconds, setRemainingSeconds] = useState(() => computeRemainingSeconds(limitDate))

    useEffect(() => {
        const update = () => setRemainingSeconds(computeRemainingSeconds(limitDate))
        update()
        if (!limitDate) return
        const interval = setInterval(update, 1000)
        document.addEventListener("visibilitychange", update)
        return () => {
            clearInterval(interval)
            document.removeEventListener("visibilitychange", update)
        }
    }, [limitDate])

    return remainingSeconds
}

export const useRefreshWhenExpired = (expired, url, onDecided) => {
    useEffect(() => {
        if (!expired) return
        let cancelled = false
        let attempts = 0
        let timer = null

        const scheduleRetry = () => {
            if (attempts < expiredRefreshAttempts) timer = setTimeout(refresh, expiredRefreshDelay)
        }

        const refresh = () => {
            attempts += 1
            axios.get(url).then(response => {
                if (cancelled) return
                if (isUnderAnalysis(response.data.fraud_status)) scheduleRetry()
                else onDecided(response.data)
            }).catch(error => {
                console.log(error)
                if (!cancelled) scheduleRetry()
            })
        }

        timer = setTimeout(refresh, expiredRefreshDelay)
        return () => {
            cancelled = true
            clearTimeout(timer)
        }
    }, [expired, url, onDecided])
}
